



















import {Component, Prop, Vue} from 'vue-property-decorator';
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import Avatar from '@/components/Avatar/Avatar.vue';

@Component({
  components: {
    swiper,
    swiperSlide,
    Avatar,
  },
})
export default class MoreOne extends Vue {
  @Prop()
  private moreData!: any;

  get swiperOptionOne() {
    return {
      direction: 'vertical',
      slidesPerView: 'auto',
      freeMode: true,
      touchReleaseOnEdges: true,
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      mousewheel: true,
    };
  }
}
